import ValidatePanel from './ValidatePanel'

export default ValidatePanel
